import { cart } from "./cart";
import { categoriesAndProperties } from "./categoriesAndProperties";
import { contactAndLegal } from "./contactAndLegal";
import { digitalProductPassport } from "./digitalProductPassport";
import { errors } from "./errors";
import { general } from "./general";
import { historicalData } from "./historicalData";
import { product } from "./product";
import { productRequest } from "./productRequest";
import { requirementsAidsdt } from "./requirementsAidsdt";
import { search } from "./search";
import { userProfile } from "./userProfile";

export const gr = {
  ...general,
  ...product,
  ...search,
  ...categoriesAndProperties,
  ...contactAndLegal,
  ...userProfile,
  ...cart,
  ...productRequest,
  ...requirementsAidsdt,
  ...historicalData,
  ...errors,
  ...digitalProductPassport,
};
